import { createSelector } from 'reselect'

const getData = (state, layerName, event) => {
  if (!event) {
    return state.data[layerName]
  } else {
    return state.data[layerName][event]
  }
}

export const makeGetEventData = () => {
  return createSelector([getData], (data) => {
    if (data) {
      return data
    } else {
      return []
    }
  })
}




// WEBPACK FOOTER //
// ./src/selectors/eventDataSelector.js